import React, { useState } from "react";
import Bunexe_service from "./Bunexe_service";
import logo3bunexe from "./components/logo3bunexe.jpg";
import { toast } from "react-toastify";

const Login = ({ setIsLogin }) => {
  const url_ = Bunexe_service.url;
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [messageErreur, setMessageErreur] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit_ = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      setMessageErreur("Veuillez remplir tous les champs.");
      return;
    }

    setIsLoading(true);
    setMessageErreur("");

    try {
      const response = await fetch(`${url_}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (data.token) {
        localStorage.setItem("token", data.token);
        setIsLogin(true);
      } else {
        const errorMsg = data.mes || "Identifiants incorrects.";
        toast.error(errorMsg, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setMessageErreur(errorMsg);
      }
    } catch (error) {
      console.error("Erreur lors de la connexion:", error);
      toast.error("Erreur de connexion au serveur.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setMessageErreur("Impossible de contacter le serveur.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container justify-content-center mt-4">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4 mt-3">
          <form
            autoComplete="off"
            className="form-signin mx-1 p-4 rounded border border-primary"
            onSubmit={onSubmit_}
          >
            <div className="d-flex justify-content-center mb-4">
              <img
                src={logo3bunexe}
                width="130px"
                height="130px"
                alt="logo Bunexe MENFP"
                className="rounded"
              />
            </div>

            <input
              type="text"
              id="inputUsername"
              className="form-control mb-4"
              placeholder="Username"
              value={username}
              onFocus={() => setMessageErreur("")}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
            />

            <input
              type="password"
              id="inputPassword"
              className="form-control mb-4"
              value={password}
              onFocus={() => setMessageErreur("")}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              required
            />

            <button
              className="btn btn-primary btn-block mb-3"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "Connexion en cours..." : "Se connecter"}
            </button>
          </form>

          {messageErreur && (
            <div className="alert alert-danger text-center mt-3" role="alert">
              {messageErreur}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
